<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;">Katy Jordan was born and raised in Stirling, Scotland. From an early age she dreamed of becoming a writer and/or actress and for the last eight years she has been pursuing both.</p><br/>
<p style="text-align: center;">Official website: www.katy-jordan.co.uk</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4646da47